import { createSlice } from "@reduxjs/toolkit";
import * as BookingApi from "../api/booking";

const bookings = createSlice({
  name: "bookings",
  initialState: {
    loading: false,
    error: null,
    list: [],
    summary: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getListSuccess: (state, action) => {
      state.list = action.payload.docs;
      state.summary = action.payload.summary;
      state.loading = false;
    },
  },
});

export const getListBooking = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await BookingApi.getListBooking(params);
    dispatch(getListSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = bookings;
export const { setLoading, setError, getListSuccess } = actions;
export default reducer;
